module.exports = __webpack_public_path__ + "img/isola_conv_sm.d281d780.png";